<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Change {{ userData.name }}'s Permission</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4" v-if="userData !== null">

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Permission
                    </label>
                    <label class="dropdown_wrap">
                        <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="role">
                            <option value="videographer">Videographer</option>
                            <option value="media_purchaser">Media Purchaser</option>
                            <option value="media_producer">Media Producer</option>
                            <option value="administrator">Administrator</option>
                            <option value="superadministrator">Super Administrator</option>
                        </select>
                    </label>
                </div>

                <div class="md:flex md:items-center mb-6" v-if="role == 'media_purchaser' || role == 'media_producer'">
                    <div class="md:w-1/3">
                        <label class="block text-grey-darkest font-bold md:text-left mb-1 md:mb-0 pr-4" for="inline-full-name">
                            Network
                        </label>
                    </div>
                    <div class="md:w-2/3">
                        <label class="dropdown_wrap">
                            <select class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="network">
                                <option v-for="network in networks" :value="network['id']">{{ network.name }}</option>
                            </select>
                        </label>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="mt-10 clearfix">
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Cancel
                </button>
                <button v-on:click="modifyPermissions" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Change Permission
                </button>
            </div>
        </div>

    </Modal>
</template>

<script>
    import { EventBus } from '../../../utils/events';
    import * as Config from '../../../config'
    import { mapState, mapGetters } from 'vuex';
    import Modal from '@/components/Modal'

    export default {
        data() {
            return {
                userData: {},
                networks: {},
                role: null,
                network: null,
                displayModal: false,
            }
        },

        components: {
            Modal
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('change-user-permissions-open-modal', this.open);
            }.bind(this));
        },

        destroyed() {
            EventBus.$off('change-user-permissions-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            open(data) {
                this.displayModal = true
                this.role = data.role;
                this.userData = data;                
            },

            modifyPermissions() {
                var _this = this;
                this.$http.post(Config.apiPath + "/api/v2/admin/users/" + this.userData.id + "/permissions", { role: this.role, network: this.network }, this.getAuthorizationHeader()).then((response) => {
                    console.log(response.status)
                    if(response.status == 200) {
                        $('#changeUserPermissions').modal('toggle'); 
                    }
                });
            },

            getNetworks() {
                var _this = this;
                this.$http.get(Config.apiPath + "/api/v2/admin/networks", this.getAuthorizationHeader()).then((response) => {
                    _this.networks = response.data
                });
            },

        },

        watch: {

            role: function(data) {
                if(data == 'media_producer' || data == 'media_purchaser') {
                    this.getNetworks();
                }
            }

        }

        
    }
</script>
